export default {"src":"/_next/static/media/ticket_eye.e6df4fba.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};